import Separator from "@/v2-ui/separator"
import type { TableSelectionToolbarProps } from "@/v2-backoffice-client/components/table"
import Table from "@/v2-backoffice-client/components/table"
import TenantUserAddManySelector from "@/v2-backoffice-client/tenant/user/add/many/TenantUserAddManySelector"
import UserCustomerUpdateManySelector from "@/v2-backoffice-client/user/customer/update/many/UserCustomerUpdateManySelector"
import UserStatusUpdateManyToolbar from "@/v2-backoffice-client/user/status/update/many/UserStatusUpdateManyToolbar"
import UserContactSyncManyButton from "@/v2-backoffice-client/user/contact/sync/many/UserContactSyncManyButton"
import UserMigrateManyButton from "@/v2-backoffice-client/user/migration/many/UserMigrateManyButton"
import type { UserFragment } from "@/v2-backoffice-client/user/__types__/user.fragment"

export type UserTableSelectionToolbarProps = Omit<
  TableSelectionToolbarProps<UserFragment>,
  "children"
> & {
  users: UserFragment[]
  reset?(): void
}

function UserTableSelectionToolbar(props: UserTableSelectionToolbarProps) {
  const { users, reset } = props

  return (
    <>
      <Table.ExportSelectionButton
        fileName="users"
        selectionCount={users.length}
      />

      {/* The same two membership actions as every other user selection:
          add the users to a team, move them to the customer that owns
          them. Both popovers, both pinned to the trigger. */}
      <TenantUserAddManySelector
        isStacked
        variant="ghost"
        users={users}
        onCompleted={reset}
        content="Add the selected users to a team."
      >
        Team
      </TenantUserAddManySelector>

      <UserCustomerUpdateManySelector
        isStacked
        variant="ghost"
        users={users}
        onCompleted={reset}
        content="Update the customer that owns the selected users: whose licenses and seats apply to them."
      >
        Customer
      </UserCustomerUpdateManySelector>

      <UserContactSyncManyButton users={users} onCompleted={reset} />

      <UserMigrateManyButton users={users} onCompleted={reset} />

      <Separator orientation="vertical" />
      <UserStatusUpdateManyToolbar users={users} onCompleted={reset} />
    </>
  )
}

export default UserTableSelectionToolbar
